import {
  displayFlashMessage,
  showLoadingMessage,
  hideLoadingMessage,
} from "../../util/methods"

$(document).on("turbolinks:load", function () {
  let $blenderDragBtn = $(".blender-drag-btn")

  if ($blenderDragBtn.length) {
    $blenderDragBtn.on("dragstart", function (e) {
      const $this = $(this)
      const blenderInstallContainer = $this.closest(
        ".blender-install-container"
      )[0]
      const dataTransferObject = e.originalEvent.dataTransfer
      if (!blenderInstallContainer || !dataTransferObject) return

      const installUrl = blenderInstallContainer.dataset.installUrl
      if (!installUrl) return

      try {
        dataTransferObject.setData("text/uri-list", installUrl)
        dataTransferObject.setData("text/plain", installUrl)
      } catch (_) {}
      dataTransferObject.effectAllowed = "copy"
      $this.addClass("is-dragging")

      $(document)
        .on("dragover.blenderDragBtn", (e) => {
          e.preventDefault()
          if (e.originalEvent.dataTransfer)
            e.originalEvent.dataTransfer.dropEffect = "copy"
        })
        .on("drop.blenderDragBtn", (e) => e.preventDefault())

      $this.one("dragend", () => {
        $(document).off("dragover.blenderDragBtn drop.blenderDragBtn")
        $this.removeClass("is-dragging")
      })
    })

    $blenderDragBtn.on("click", (e) => e.preventDefault())
  }

  var $versionSelects = $(".js-version-select")

  if ($versionSelects.length) {
    $versionSelects.each(function () {
      let $this = $(this)

      $this.select2({
        width: "100%",
        minimumResultsForSearch: Infinity, // this is to hide the search bar
      })

      $this.on("change", function () {
        let $this = $(this)
        let version_id = $this.val()
        let $downLoadsList = $this
          .closest(".order-pickup-files")
          .find(".js-downloads-list")

        showLoadingMessage("Fetching version downloads")

        $.ajax({
          url: $this.data("url"),
          method: "get",
          dataType: "json",
          data: { version_id: version_id },
          success: function (data) {
            hideLoadingMessage()
            $downLoadsList.html(data["html"])
            const $installContainer = $this
              .closest(".order-pickup-files")
              .find(".blender-install-container")
            $installContainer
              .find(".non-extension-compatible-overlay")
              .toggleClass("is-active", !data["install_url"])
            if (data["install_url"]) {
              $installContainer.attr("data-install-url", data["install_url"])
            }
          },
          error: function (xhr, status, error) {
            hideLoadingMessage()
            displayFlashMessage("danger", "Failed to fetch version downloads")
            $downLoadsList.html(
              '<small class="text-danger d-block font-italic">Failed to fetch version downloads</small>'
            )
            console.log("Error: ", error)
          },
        })
      })
    })
  }
})
